import { useState, useEffect, useContext } from "react";
import { Grid, Stack, Box, GTIWebSelect, GTIWebDataGrid } from "@gti-controls-v2/web-core";
import useSearch from "../../../hooks/useSearch";
import { SettingsContext } from "../../../providers/settings";
import homePageStyles from "../../../common/styles/HomePage";
import DateRangeFilter from "../../../components/date-range-filter";

const Support = ({ TicketID, data }) => {
    const styles = homePageStyles;
    const dateFormat = "DD/MMM/YYYY";
    const today = new Date(new Date().toLocaleString("en-US", {timeZone: "PST"}));
    const lastYear = new Date(today);
    lastYear.setFullYear(today.getFullYear() - 1);

    const { handleLoading } = useContext(SettingsContext);
    const { getTicketLogsPorEmpleado } = useSearch();
    const [soportesResult, setSoportesResult] = useState([]);
    const [responsableID, setResponsableID] = useState(0);
    const [dateTicket, setDateTicket] = useState({
        startDate: lastYear.toISOString().split('T')[0],
        endDate: today.toISOString().split('T')[0]
    });
    const [flag, setFlag] = useState(false);
    
    const soporteGridColumns = [
        { field: "SoporteAsesor", headerName: "Responsable", width: "30%" },
        { field: "SoporteTipo", headerName: "Motivo", width: "30%" },
        { field: "SoporteResumen", headerName: "Descripción", width: "20%" },
        { field: "SoporteCreated", headerName: "Fecha", width: "20%" },
    ];

    useEffect(() => {
        init();
        // eslint-disable-next-line
    }, [data]);

    const init = async () => {
        if (!flag) {
            setSoportesResult(data?.[1]?.data);
            setFlag(true);
        }
    };

    useEffect(() => {
        cargarDatosGridSoporte();
        // eslint-disable-next-line
    }, [dateTicket, responsableID]);

    const cargarDatosGridSoporte = async() =>  {
        if (flag) {
            handleLoading(true);
            
            const resultado = await getTicketLogsPorEmpleado(TicketID, dateTicket.startDate, dateTicket.endDate, responsableID);
            setSoportesResult(resultado.data);    
        
            handleLoading(false);
        }
    };

    const onChangeFiltroSoporte = (event) =>{
        if (!flag) return;

        switch (event.target.name) {
            case "responsable":
                setResponsableID(event.target.value);
                break;
            case "dateRange":
                setDateTicket(event.target.value);
                break;
            default:
                break;
        }
    };

    return (
        <Grid label="Soporte" direction="column" sx={styles.supportContainer}>
            <Stack direction="row" spacing={3} sx={styles.supportFilters} paddingBottom={4}>
                <Stack direction="column" sx={styles.supportLookup}>
                    <Box>
                        <GTIWebSelect
                            name="responsable"
                            dataSource={data?.[0]?.data ?? []}
                            displayedValue="UsuarioName"
                            selectedValue="UsuarioID"
                            labelText= "Responsable"
                            color={"secondary"}
                            disableDefaultReadOnly
                            onChange={onChangeFiltroSoporte}
                        />
                    </Box>
                </Stack>
                <Stack direction="column" sx={styles.supportDatePicker}>
                    <DateRangeFilter
                        name="fecha"
                        labelStart="Fecha inicial:"
                        labelEnd="Fecha final:"
                        labelTo="-"
                        dateFormat={dateFormat}
                        width="100%"
                        onChange={onChangeFiltroSoporte}
                        value={dateTicket}
                    />
                </Stack>
            </Stack>
            
            <Stack>
                <Grid container>
                    <GTIWebDataGrid 
                        pageSize={20}
                        rows={soportesResult}
                        columns={soporteGridColumns}
                        getRowId={(r) => r.TicketID}
                    />
                </Grid>
            </Stack>
        </Grid>
    )
};

export default Support;